import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import Popup from 'popup/Popup';

import { ColumnSetPopupContainer } from './ColumnSetPopup.css';
import { mainSettingUpdate } from 'redux/action/mainSetting1';

const ColumnSetPopup = () => {
  const dispatch = useDispatch();
  const columnSetting = useSelector((state) => state.mainSetting1.board.columns);
  const userIdx = useSelector((state) => state.loginManager.status.userIdx);
  const flag_ch4_hc = useSelector((state) => state.settings.setting.flag_ch4_hc);
  const [popupOpen, setPopupOpen] = useState(false);
  const { register, handleSubmit, errors } = useForm();
  const confirmColumns = (data) => {
    dispatch({ type: 'BOARD_COLUMN_SET', data: data.column });
    dispatch(mainSettingUpdate(data.column, userIdx));
    setPopupOpen(false);
  };

  return (
    <Popup
      trigger={
        <div>
          <button className="btn btn-primary">Edit</button>
        </div>
      }
      modal
      closeOnDocumentClick
      open={popupOpen}
      onOpen={() => {
        setPopupOpen(true);
      }}
    >
      <ColumnSetPopupContainer>
        <div className="title">테이블 커스터마이징</div>
        <form onSubmit={handleSubmit(confirmColumns)}>
          <div>
            <label>
              <input type="checkbox" name="column" ref={register()} value={'logIdx'} defaultChecked={columnSetting.indexOf('logIdx') !== -1} /> No.
            </label>
          </div>

          <div>
            <label>
              <input type="checkbox" name="column" ref={register()} value={'areaNm'} defaultChecked={columnSetting.indexOf('areaNm') !== -1} /> 위치
            </label>
          </div>
          
          <div>
            <label>
              <input type="checkbox" name="column" ref={register()} value={'userDt'} defaultChecked={columnSetting.indexOf('userDt') !== -1} />{' '}
              건조부
            </label>
          </div>
          
          <div>
            <label>
              <input type="checkbox" name="column" ref={register()} value={'userSt'} defaultChecked={columnSetting.indexOf('userSt') !== -1} />{' '}
              안전부
            </label>
          </div>
          
          <div>
            <label>
              <input type="checkbox" name="column" ref={register()} value={'userSc'} defaultChecked={columnSetting.indexOf('userSc') !== -1} />{' '}
              선커부
            </label>
          </div>

          <div>
            <label>
              <input type="checkbox" name="column" ref={register()} value={'modelNo'} defaultChecked={columnSetting.indexOf('modelNo') !== -1} />{' '}
              감지기No.
            </label>
          </div>
          <div>
            <label>
              <input disabled type="checkbox" name="column" ref={register()} value={'o2'} defaultChecked={columnSetting.indexOf('o2') !== -1} /> O<sub>2</sub>
              (%)
            </label>
          </div>
          <div>
            <label>
              <input type="checkbox" name="column" ref={register()} value={'h2s'} defaultChecked={columnSetting.indexOf('h2s') !== -1} /> H
              <sub>2</sub>S(ppm)
            </label>
          </div>
          <div>
            <label>
              <input type="checkbox" name="column" ref={register()} value={'co'} defaultChecked={columnSetting.indexOf('co') !== -1} /> CO(ppm)
            </label>
          </div>
          <div>
            <label>
              <input type="checkbox" name="column" ref={register()} value={'hc'} defaultChecked={columnSetting.indexOf('hc') !== -1} /> {flag_ch4_hc !== '0' ? 'HC' : (<>CH<sub>4</sub></>)}
              (%)
            </label>
          </div>
          <div>
            <label>
              <input type="checkbox" name="column" ref={register()} value={'co2'} defaultChecked={columnSetting.indexOf('co2') !== -1} /> CO
              <sub>2</sub>(%)
            </label>
          </div>
          <div>
            <label>
              <input type="checkbox" name="column" ref={register()} value={'methanol'} defaultChecked={columnSetting.indexOf('methanol') !== -1} /> methanol
            </label>
          </div>
          <div>
            <label>
              <input type="checkbox" name="column" ref={register()} value={'nh3'} defaultChecked={columnSetting.indexOf('nh3') !== -1} /> NH3
            </label>
          </div>
          <div>
            <label>
              <input type="checkbox" name="column" ref={register()} value={'status'} defaultChecked={columnSetting.indexOf('status') !== -1} /> 상태
            </label>
          </div>
          <div>
            <label>
              <input type="checkbox" name="column" ref={register()} value={'battery'} defaultChecked={columnSetting.indexOf('battery') !== -1} />{' '}
              배터리
            </label>
          </div>
          <div>
            <label>
              <input type="checkbox" name="column" ref={register()} value={'rgstDt'} defaultChecked={columnSetting.indexOf('rgstDt') !== -1} />{' '}
              측정시간
            </label>
          </div>
          <div className="btn-box">
            <button type="submit" className="btn btn-primary">
              저장
            </button>
          </div>
        </form>
      </ColumnSetPopupContainer>
    </Popup>
  );
};

export default ColumnSetPopup;
